<template>
  <v-app>
    <v-container
      id="user-profile"
      fluid
      tag="section"
    >
      <v-row justify="center">
        <v-col
          lg="4"
          md="6"
        >
          <div class="text-center">
            <h1>LOGIN</h1>
          </div>
          <v-card
            ref="form"
            class="mx-auto my-auto w-100"
          >
            <v-card-text>
              <v-form>
                <v-container class="py-0">
                  <v-row
                    justify="center"
                  >
                    <v-col
                      cols="12"
                      class="text-right"
                    >
                      <v-text-field
                        ref="name"
                        v-model="name"
                        :rules="[() => !!name || 'Este campo es requerido']"
                        label="Usuario"
                        required
                      />
                    </v-col>
                  </v-row>
                  <v-row
                    justify="center"
                  >
                    <v-col
                      cols="12"
                      class="text-right"
                    >
                      <v-text-field
                        ref="password"
                        v-model="password"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[() => !!password || 'Este campo es requerido']"
                        :type="show1 ? 'text' : 'password'"
                        name="input-10-1"
                        label="Contraseña"
                        @click:append="show1 = !show1"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      class="text-center"
                    >
                      <span
                        v-if="errorLogin"
                        class="warning--text"
                      >
                        Hubo un error al inicar sesión
                      </span>
                      <v-btn
                        color="success"
                        class="mr-0"
                        block
                        :loading="isLoading"
                        @click="SignIn()"
                      >
                        Entrar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
  import router from '../../router'
  import { mapActions } from 'vuex'
  import firebase from 'firebase'
  require('firebase/auth')

  export default {
    data () {
      return {
        errorLogin: false,
        isLoading: false,
        show1: false,
        name: null,
        password: '',
        formHasErrors: false,
      }
    },
    methods: {
      ...mapActions(['setUser']),
      SignIn () {
        this.errorLogin = false
        this.isLoading = true
        firebase.auth().signInWithEmailAndPassword(this.name, this.password).then((user) => {
          firebase.firestore().collection('users').doc(user.user.uid).get().then((doc) => {
            if (doc.exists) {
              this.setUser(JSON.stringify(doc.data()))
              if (doc.data().perfil === 'Administrador') {
                router.push({ path: '/' })
              } else {
                router.push({ path: '/proyectos/prospeccion' })
              }
              this.isLoading = false
            } else {
              this.isLoading = false
              this.errorLogin = true
            }
          }).catch(() => {
            this.isLoading = false
            this.errorLogin = true
          })
        }).catch(() => {
          this.isLoading = false
          this.errorLogin = true
        })
      },
    },
  }
</script>
